// supported dropzone file types
export enum AcceptTypes {
    DOC,
    DOCX,
    XLS,
    XLSX,
    PDF,
}

export enum FileTypePurpose {
    COMMUNICATION,
}

// supported dropzone file types and mimes
const AcceptFileTypes: {
    [key in AcceptTypes]: { [mimeType: string]: string[] };
} = {
    [AcceptTypes.DOC]: { "application/msword": [".doc"] },
    [AcceptTypes.DOCX]: {
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document": [".docx"],
    },
    [AcceptTypes.XLS]: { "application/vnd.ms-excel": [".xls"] },
    [AcceptTypes.XLSX]: {
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [".xlsx"],
    },
    [AcceptTypes.PDF]: { "application/pdf": [".pdf"] },
};

// get supported dropzone file formats for specific purpose
export const AcceptFileType: { [key in FileTypePurpose]: { [mimeType: string]: string[] } } = {
    [FileTypePurpose.COMMUNICATION]: {
        ...AcceptFileTypes[AcceptTypes.DOC],
        ...AcceptFileTypes[AcceptTypes.DOCX],
        ...AcceptFileTypes[AcceptTypes.XLS],
        ...AcceptFileTypes[AcceptTypes.XLSX],
        ...AcceptFileTypes[AcceptTypes.PDF],
    },
};